import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

import PropTypes from "prop-types";
import CustomInput from "components/CustomInput/CustomInput.js";
let timestamp = null;
function SearchInput(props) {
  const [input, setInput] = React.useState("");

  const [list, setList] = React.useState([]);
  const [selectedElement, setSelectedElement] = React.useState(0);
  const { getElementSelected, search } = props;
  useEffect(() => {
    setList([]);
    setInput("");
  }, [props.location.search]);

  const getList = () => {
    return (
      <div className="results-list-container" style={{ position: "absolute" }}>
        {list.map((el, index) => {
          let icon = "icon icon-Pin-24";
          if (el.alias && el.category) {
            icon = `icon icon-category${el.category}-24`;
          }
          return (
            <div
              key={`${el.id ? el.id.toString() : el._id.toString()}`}
              className={`results-list-element ${
                selectedElement === index ? "selected" : ""
              }`}
              onMouseOver={() => {
                setSelectedElement(index);
              }}
              onClick={() => {
                getElementSelected(list[selectedElement]);
              }}
            >
              <i
                className={icon}
                style={{ fontSize: "30px", marginRight: "10px" }}
              />
              {el.name}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="footer-search-border">
      {props.label ? (
        <span className="search-input-label">{props.label}</span>
      ) : null}
      <CustomInput
        formControlProps={{ fullWidth: false }}
        labelText={props.placeholder || "Cerca"}
        inputProps={{
          value: input,
          className: "search-input",

          onKeyDown: e => {
            switch (e.key) {
              case "Enter":
                getElementSelected(list[selectedElement]);
                break;
              case "ArrowDown":
                if (selectedElement < list.length) {
                  setSelectedElement(selectedElement + 1);
                }
                break;
              case "ArrowUp":
                if (selectedElement > 0) {
                  setSelectedElement(selectedElement - 1);
                }
                break;
              case "Escape":
                setList([]);
                break;
              default:
                break;
            }
          },
          onChange: e => {
            setInput(e.target.value);
            timestamp = Date.now();
            if (e.target.value && e.target.value.length > 2) {
              // const timestamp = new Date().getTime();
              return search(e.target.value, timestamp)
                .then(res => {
                  console.log("res", res);

                  if (!res) {
                    setList([]);
                  } else if (
                    res.timestamp &&
                    res.timestamp === timestamp.toString()
                  ) {
                    console.log("entro qui", res.timestamp, res);
                    setList(res.results);
                  } else {
                    console.log("efojkefefoefowefiow");
                  }
                })
                .catch(err => {
                  console.log("errore", err);
                });
            } else if (list && list.length > 0) {
              setList([]);
            }
          }
        }}
        classAdd={"labelRootSearch"}
      />
      {list && list.length > 0 ? (
        <div style={{ position: "relative" }}>{getList()}</div>
      ) : null}
    </div>
  );
}

SearchInput.propTypes = {
  getElementSelected: PropTypes.func,
  search: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string
};

SearchInput.defaultProps = {
  label: "",
  placeholder: ""
};
export default withRouter(SearchInput);
